<app-profile *ngIf="loggedIn; else plainLayout"></app-profile>

<ng-template #plainLayout>
    <div class="section over-hide">
        <div class="section padding-top-120 padding-top-mob-nav section-background-rana">
            <div class="section-1400 pt-xl-4 padding-bottom-40 margin-auto">
                <div class="container-fluid padding-40 card" [ngSwitch]="view">
                    <app-biz-detail *ngSwitchCase="'bizDetail'"></app-biz-detail>
                    <app-biz-form *ngSwitchCase="'bizForm'"></app-biz-form>
                    <app-biz-opportunities *ngSwitchCase="'bizOpps'"></app-biz-opportunities>
                    <app-biz-start-up *ngSwitchCase="'bizStart'"></app-biz-start-up>
                    <app-biz-directory *ngSwitchDefault></app-biz-directory>
                </div>
            </div>
        </div>
    </div>
</ng-template>
